import { Eye } from "@phosphor-icons/react";
import "./access.css";

/**
 * Inside a page/modal opened on someone else's entity without write
 * permission (multi-clinic v2 §2.6).
 */
function ReadOnlyBanner({ text = "תצוגה בלבד — התור/המטופל שייך למטפל/ת אחר/ת." }) {
  return (
    <div className="ck-readonly-banner" role="note">
      <Eye size={16} weight="fill" />
      <span>{text}</span>
    </div>
  );
}

export default ReadOnlyBanner;
